/**
 * HOOK: useNormative
 *
 * Gestiona el estado de la versión normativa activa y la bitácora de
 * eventos normativos (normativeAudit). Consulta la API REST para obtener
 * ambos.
 * Extraído de App.jsx como parte de refactor convivencia.
 *
 * Convivencia: este hook corre en paralelo con el código inline de App.jsx.
 * Ambos hacen fetch a la misma API — la segunda llamada es redundante pero
 * no modifica el resultado final (setNormativeVersion es idempotente).
 */

import { useState, useEffect } from 'react'

export function useNormative() {
  const [normativeVersion, setNormativeVersion] = useState('N/D')
  const [normativeAudit, setNormativeAudit] = useState([])

  /**
   * Obtener bitácora de eventos normativos (últimos 5)
   * Refleja el mismo comportamiento que el useEffect inline en App.jsx
   */
  useEffect(() => {
    let active = true
    ;(async () => {
      try {
        const response = await fetch('/api/normative/audit?limit=5')
        if (!response.ok) return
        const data = await response.json()
        if (active) setNormativeAudit(Array.isArray(data?.data) ? data.data : [])
      } catch {
        if (active) setNormativeAudit([])
      }
    })()
    return () => { active = false }
  }, [])

  /**
   * Obtener versión normativa activa
   * Refleja el mismo comportamiento que el useEffect inline en App.jsx
   */
  useEffect(() => {
    let active = true
    ;(async () => {
      try {
        const response = await fetch('/api/normative/rules/active')
        if (!response.ok) return
        const data = await response.json()
        const version = data?.data?.version || data?.data?.id || 'N/D'
        if (active) setNormativeVersion(version)
      } catch {
        if (active) setNormativeVersion('N/D')
      }
    })()
    return () => { active = false }
  }, [])

  return {
    normativeVersion,
    setNormativeVersion,
    normativeAudit,
  }
}
